<template>
  <div>
    <base-crud
      crudName="Reserva de Veículo"
      newText="Nova Reserva"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="true"
      :dataForm="dataForm"
      :customFilters="customFilters"
      @filtered="filtered"
      :extra="extra"
      @editing="editing"
      @cancel="cancel"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "retreat_date",
          type: "calendar",
          call: "filtered",
        },
      ],

      retreat_date: "",

      table: "reserve_vehiclesTable",
      // pages: [],
      // url: '',
      columns: [
        "id",
        "user_id",
        "vehicle_id",
        "vehicle_board",
        "retreat_date",
        "reserve_status",
        "actions",
      ],
      tableData: [
        "id",
        "user_id",
        "vehicle_id",
        "vehicle_board",
        "retreat_date",
        "reserve_status",
      ],
      options: {
        sortable: [
          "id",
          "user_id",
          "vehicle_id",
          "vehicle_board",
          "retreat_date",
          "reserve_status",
        ],
        columns: [
          "id",
          "user_id",
          "vehicle_id",
          "vehicle_board",
          "retreat_date",
          "reserve_status",
          "actions",
        ],
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "user_id",
          "vehicle_id",
          "vehicle_board",
          "branch_id",
          "reserve_status",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Nome do Usuário",
          vehicle_id: "Veículo",
          vehicle_board: "Placa Veículo",
          retreat_date: "Data de Retirada",
          reserve_status: "Status da Reserva",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          reserve_status: [
            {
              id: 1,
              text: "Pré-reserva",
            },
            {
              id: 2,
              text: "Reservado",
            },
            {
              id: 3,
              text: "Cancelado",
            },
            {
              id: 4,
              text: "Retirado",
            },
            {
              id: 5,
              text: "Devolvido",
            },
          ],
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          reserve_status: function (h, row, index) {
            return row.reserve_statuses
              ? row.reserve_statuses.title
              : "Sem Nome";
          },
          vehicle_id: function (h, row, index) {
            return row.vehicle_id ? row.vehicles.description : "Sem Nome";
          },
          vehicle_board: function (h, row, index) {
            return row.vehicle_id ? row.vehicles.board : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);

          requestData.params = data;

          if (
            this.$parent.$parent.retreat_date != null &&
            this.$parent.$parent.retreat_date != ""
          ) {
            requestData.params.retreat_date = this.$parent.$parent.retreat_date;
          }

          requestData.params.query = "";
          requestData.params.with = [
            "user",
            "branch",
            "reserve_statuses",
            "vehicles",
          ];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "fas fa-pencil-alt btn btn-crud edit2",
          title: "Editar",
          name: "editing",
          icon: "btn btn-crud edit2",
        },
        {
          id: 2,
          label: "",
          class: "btn btn-crud cancel fas fa-ban",
          title: "Cancelar Reserva",
          name: "cancel",
          icon: "fas fa-ban",
        },
      ],
      endPoint: "myreserves/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    filtered(date) {
      this.retreat_date = date;
    },
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        retreat_date: "retreat_date",
        vehicle_id: "vehicles[description]",
        vehicle_board: "vehicles[board]",
        reserve_status: "reserve_status[title]",
      };

      let filters = "orderByDesc=retreat_date&";

      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
        console.log(value);
      });
      return filters;
    },
    editing: function (props, row, index) {
      const self = this;

      if (props.row.reserve_status == "4" || props.row.reserve_status == "5") {
        swal(
          "Erro",
          "Esta reserva não pode ser alterada, pois já existe check-out/check-in realizado",
          "info"
        );
      } else if (props.row.reserve_status == "3") {
        swal(
          "Erro",
          "Esta reserva não pode ser alterada, pois está cancelada",
          "info"
        );
      } else {
        this.$router.push({
          path: this.endPoint + "edit/" + props.row.id,
        });
      }
    },
    cancel: function (props, row, index) {
      const self = this;

      if (props.row.reserve_status == "4" || props.row.reserve_status == "5") {
        swal(
          "Erro",
          "Esta reserva não pode ser alterada, pois já existe check-out/check-in realizado",
          "info"
        );
      } else if (props.row.reserve_status == "3") {
        swal(
          "Erro",
          "Esta reserva não pode ser alterada, pois está cancelada",
          "info"
        );
      } else {
        self.save(props);
      }
    },

    save(props) {
      const self = this;

      let api = self.$store.state.api + "reserveVehicles/" + props.row.id;
      let fd = new FormData();

      fd.append("_method", "PATCH");
      fd.append("agent", "WEB");
      fd.append("observation", "Cancelado via Portal Admin");
      fd.append("reserve_status", "3");

      swal({
        title: "Deseja cancelar a reserva?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, cancelar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      })
        .then((value) => {
          switch (value) {
            case "cancel":
              swal("Cancelado", "A reserva não foi cancelada!", "info");
              break;

            case "confirm":
              self.$http.post(api, fd).then((response) => {
                props.row.vehicle_status_id = status;
                swal("Sucesso", "Reserva cancelada com sucesso!", "success");
                props.row.reserve_statuses.title = "Cancelado";
                $(function () {
                  setTimeout(function () {
                    location.reload();
                  }, 1000);
                });
              });
              break;
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    localStorage.setItem( 'agent', 'web' );
  },
  computed: {},
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/Crud.vue